import React, {
	Fragment,
	useState,
	useEffect
} from 'react'
import { useHistory } from "react-router-dom"
import {
	useSelector,
	useDispatch
} from 'react-redux'
import {
	getRecentNotes,
	selectAllNotes,
	saveNote,
	deleteNote,
	updateNote,
	initNotes
} from '../../state/clientNotesSlice'
import {
	setClientKey,
	selectUserById,
	removeTagFromClient,
	getAllClients,
    selectClientsById,
    addTagToClient,
} from '../users/usersSlice'

import {
	envAwareFormSubmit,
	envAwarePost,
	dateToAPIStandard,
	ellipsis
} from '../../util/util'
import {useTags} from '../../hooks/useTags'
import {
    getAllTags,
	insertTag,
    updateTagColor,
    
} from '../../state/accountTagsSlice'
import CreatableSelect from 'react-select/creatable'
import Button from 'react-bootstrap/Button'
import Spinner from "react-bootstrap/Spinner"
import Form from 'react-bootstrap/Form'
import InputGroup from 'react-bootstrap/InputGroup'
import Modal from 'react-bootstrap/Modal'
import Popover from 'react-bootstrap/Popover'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import useDirectUpload from '../../hooks/useDirectUpload' //DEPRECATED use useS3DirectUploadInstead
import useS3DirectUpload from '../../hooks/useS3DirectUpload'
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import {capitalize} from '../../util/util'
import { CirclePicker } from 'react-color'
import useAccountTypeName from '../../hooks/useAccountTypeName'

const dateToAPIForm = date =>(
	Boolean(date)?
	//get YYYY-MM-DD HH:MM:SS from date object
	// mm/dd/yyy
	`${date.getFullYear()+'-'+('0' + (date.getMonth()+1)).slice(-2)+'-'+date.getDate()}`:
	''
)

const Note = props =>{
	const dispatch = useDispatch()
	const {note,dateCreated,note_id,client_id} = props.note
	const [mode,setMode] = useState('read')
	const [newNote,setNewNote] = useState(note)
	const cancelEdit = ()=>{
		setMode('read')
	}
	const saveHandler = ()=>{
		setMode('read')
		dispatch(updateNote({
			dateCreated:dateToAPIStandard(new Date()),
			note:newNote,
			note_id,
		}))
	}
	const deleteHandler = ()=>{
		if(!window.confirm('Are you sure?')) return
		dispatch(deleteNote({
			client_id,
			note_id
		}))
	}

	return (
		<div className="border p-2 mb-2 rounded">
			{
				mode === 'read' ?
				note :
				<Form.Control as="textarea" value={newNote} onChange={e=>setNewNote(e.target.value)}/>
			}
			<hr className="my-1"/>
			<div className="d-flex justify-content-between">
				{
					mode === 'read'?
					<div>
						<small onClick={()=>setMode('edit')} className="mr-2">edit</small>
						<small onClick={deleteHandler} className="text-danger">delete</small>
					</div>:
					<div>
						<small onClick={cancelEdit} className="mr-2">cancel</small>
						<small onClick={saveHandler} className="text-success">save</small>
					</div>
				}
				<small>
					{new Date(dateCreated?.split(' ').join('T')).toLocaleString()}
				</small>
			</div>
		</div>
	)
}

const Notes = ({clientId})=>{
	const dispatch = useDispatch()
	const notes = useSelector(selectAllNotes)
	const recentNote = useSelector(state=>selectAllNotes(state)[0])
	const [newNote,setNewNote] = useState('')
	const [addingNote,setAddingNote] = useState(false)
	const [showNotesModal,setShowNotesModal] = useState(false)
	const [offset,setOffset] = useState(0)
	const saveHandler = ()=>{
		dispatch(saveNote({
			client_id:clientId,
			dateCreated:dateToAPIStandard(new Date()),
			newNote,
		}))
	}
	const recentHandler = ()=>{
		dispatch(getRecentNotes({
			client_id:clientId,
			offset:notes.length,
			limit:10
		}))
	}
	useEffect(()=>{
		dispatch(initNotes({
			client_id:clientId,
			offset:0,
			limit:10
		}))
	},[clientId])
	if(!clientId) return null
	return (
		<div className="border rounded p-3 bg-light">
			<div className="d-flex align-items-center justify-content-between">
				<h2>Notes</h2>
				<Button 
					className="fa fa-plus" 
					variant="outline-primary" 
					onClick={()=>setAddingNote(!addingNote)} />
			</div>
			{addingNote&&
				<div>
					<Form.Control 
						value={newNote} 
						onChange={e=>setNewNote(e.target.value)} 
						as="textarea"/>
					<div>
						<Button 
							onClick={()=>setAddingNote(!addingNote)} 
							variant="outline-danger">
							Cancel
						</Button>
						<Button onClick={saveHandler} variant="outline-success">
							Save
						</Button>
					</div>
				</div>
			}
			<span>Most Recent:</span>
			<div>
				{
					recentNote?
					<Note note={recentNote}/>:
					'No notes'
				}
			</div>
			<Button 
				onClick={()=>setShowNotesModal(true)}
				variant="outline-dark" 
				block
				className="mt-2">
				View all notes
			</Button>
			<Modal show={showNotesModal} onHide={()=>setShowNotesModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>Notes</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{notes.map(note=>(
						<Note note={note}/>
					))}
				</Modal.Body>
				<Modal.Footer>
					<Button onClick={recentHandler} variant="primary">Load more</Button>
				</Modal.Footer>
			</Modal>
		</div>
	)
}
const Tag = ({tag,clientId})=>{
	const dispatch = useDispatch()
	const {color} = tag
	const colorChangeHandler = (colorObj)=>{
		const {hex} = colorObj
		dispatch(updateTagColor({
			tag_id:tag.id,
			color:hex
		}))
	}
	return (
		<span style={{position:'relative'}} className="m-1">
			<span className="rounded border d-flex" style={{overflow:'hidden'}}>
				<OverlayTrigger rootClose trigger="click" placement="top" overlay={
					<Popover>
						<Popover.Content>
							<CirclePicker onChangeComplete={colorChangeHandler}/>
						</Popover.Content>
					</Popover>
				}>
					<button style={{
						width:'24px',
						background:color,
						border:'none'
					}}/>
				</OverlayTrigger>
				<small className="d-block py-1 px-3" style={{textWrap:'nowrap'}}>
					{tag.name}
				</small>
			</span>
			<button
				onClick={()=>{
					dispatch(removeTagFromClient({
						tag_id:tag.id,
						client_id:clientId
					}))
				}}
				className="bg-danger text-white d-block"
				style={{
					borderRadius:'80px',
					fontSize:'8px',
					border:'none',
					position:'absolute',
					top:'-4px',
					right:'-4px',
					width:'12px',
					height:'12px'
				}}/>
		</span>
	)
}

const Tags = ({clientId})=>{
	const dispatch = useDispatch()
	const client = useSelector(state=>selectClientsById(state,clientId))
	//pull tags from the accountTags slice
	const tags = useSelector(state=>{
		if(!client) return []
		return client.tags.map(tag=>state.accountTags.adapter.entities[tag.id]).filter(tag=>Boolean(tag))

	})
	const allTags = useTags('all')
	const [error,setError] = useState(false)
	const [newTag,setNewTag] = useState('')
	const addTagHandler = ()=>{
		if(Boolean(newTag)){
			setError(true)
			setNewTag('')
			envAwarePost('api/users/api/',{
				action:'addTagToClient',
				tag_name:newTag.value,
				client_id:clientId
			}).then(res=>{
                dispatch(insertTag(res.data))
				dispatch(addTagToClient({
					tag:res.data,
					clientId
                }))

			})
		}
		
	}
	if(!client) return null
	return (
		<div className="border rounded p-3 bg-light">
			<h2 className="text-center">Tags</h2>
			<div>

				<div className="mb-3 d-flex">
					<CreatableSelect
						isClearable
						className="w-100 mr-1"
						default={newTag}
						onChange={tag=>setNewTag(tag)}
						options={allTags.map(
							tag=>({
								value:tag.name,
								label:tag.name
							})
						)}
					/>
					<Button 
						disabled={!Boolean(newTag)}
						onClick={addTagHandler}
						variant={Boolean(newTag)?"outline-success":"outline-secondary"}
					>
						<i className="fa fa-plus"/>
					</Button>
				</div>
			</div>
			<div className="d-flex flex-wrap">
				{tags.map(tag=>(
					<Tag clientId={clientId} tag={tag}/>
				))}
			</div>
		</div>
	)
}
const Uploads = ({ clientId, newOtherFile, newContract, newContractHandler, newOtherFileHandler }) => {
	const client = useSelector(state=>selectClientsById(state,clientId))
	const emailClientPARQ = ()=>{
		const confirmText = "Would you like to send your client a link to the online PAR-Q for them to fill out themselves? You will then be able to view it online or print it out."
		if(!window.confirm(confirmText)) return 
		envAwarePost('/emailPARQMobWeb',{
			client_email:client.user_email,
			client_id:clientId,
			client_name:client.user_name
		})
	}
	return (
		<div className="border rounded p-3 bg-light container">
			<h2 className="text-center">Uploads</h2>
			<div class="form-group row">
				<label for="file1" class="col-sm-5 col-form-label">Online PAR-Q<br/><small>Optional</small></label>
				<div class="col-sm-7">
					<a href={`/parQ/?client=${clientId}`}>
						{
							Boolean(client?.onlinePARQExists)?
							'Edit/View':
							'Create Here'
						}
					</a>
					<span className="mx-2">or</span>
					<button 
						style={{border:'none',background:'none'}} 
						className="text-primary"
						onClick={emailClientPARQ}
					>
						Have Client Update
					</button>
				</div>
			</div>
			<div class="form-group row">
				<label for="file1" class="col-sm-5 col-form-label">Upload New Contract<br/><small>Optional</small></label>
				<div class="col-sm-7">
					<Form.File 
						className="mt-2"
						onChange={newContractHandler}
						label="New Contract" custom
					/>
					{Boolean(newContract) && ellipsis(newContract.name,40)}
					{
						Boolean(client?.contract)&&
						<div>
							<a className="mr-2" href={client?.contract}>View Existing</a>
							<small>Uploading a new file will overwrite the existing Upload.</small>
						</div>
					}
				</div>
			</div>
			<div class="form-group row">
				<label for="file1" class="col-sm-5 col-form-label">Upload Another File<br/><small>Optional</small></label>
				<div class="col-sm-7">
					<Form.File 
						className="mt-2"
						onChange={newOtherFileHandler}
						label="New File" custom
					/>
					{Boolean(newOtherFile) && ellipsis(newOtherFile.name,40)}
					{
						Boolean(client?.par_q)&&
						<div>
							<a className="mr-2" href={client?.par_q}>View Existing</a>
							<small>Uploading a new file will overwrite the existing Upload.</small>
						</div>
					}
				</div>
			</div>
		</div>
	)
}

const GymOptions = ({clientId,trainerId,onTrainerSelect})=>{
	const [trainers,setTrainers] = useState([])
	const client = useSelector(state=>selectClientsById(state,clientId))
    let gymId = useSelector(state => state.users.current_user.gym_id)
    const resolvedClientAccountName = useAccountTypeName('client')
    const resolvedGymAccountName = capitalize(useAccountTypeName('gym'))
    
	useEffect(()=>{
		envAwarePost('/api/users/api/',{
			action:'getAllTrainers'
		}).then(res=>{
			setTrainers(res.data)
		})
	},[])
	//console.log('GYMID: ', gymId)

	let alternateId = useSelector(state => state.users.current_user.user_id_number)
	//console.log('alternateID: ', alternateId)
	if(gymId !== undefined){
		alternateId = gymId
	}
	return (
		<div className="border rounded p-3 bg-light container">
			<h2 className="text-center">{resolvedGymAccountName} Options</h2>
            <label>{resolvedClientAccountName} Trainer</label>
			<Form.Control 
				onChange={e=>onTrainerSelect(e.target.value)}
				value={trainerId} 
				as="select" 
				custom
			>
				<option value={0}>None</option>
				<option value={alternateId}>Shared</option>
				{trainers.map(trainer=>(
					<option value={trainer.user_id_number}>
						{trainer.user_name}
					</option>
				))}
			</Form.Control>
		</div>
	)
}

const ChangePasswordModal = ({show,clientId,setShow})=>{
	const client = useSelector(state=>selectClientsById(state,clientId))
	const [newPassword,setNewPassword] = useState('')
	const saveHandler = ()=>{
		envAwarePost('/clientAddEditDeleteMobWeb',{
			clientPassword:newPassword,
			clientEmail:client.user_email,
			client_id:clientId,
			operation:'changePassword'
		}).then(res=>{	
			const {success,message} = res
			alert(res.message)
			if(success === '1') setShow(false)
		})
	}
	return (
		<Modal
			show={show}
			onHide={() => setShow(false)}
		>
			<Modal.Header closeButton>
				<Modal.Title>
					Change Client's Password
				</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Form.Group>
					<Form.Label>Password</Form.Label>
					<Form.Control 
						onChange={e=>setNewPassword(e.target.value)}
						value={newPassword} 
						id="newPassword" 
						name="newPassword" 
						type="password" 
						placeholder="Password"
					/>
				</Form.Group>
				<Button onClick={saveHandler} block>Save</Button>
			</Modal.Body>
		</Modal>
	)
}

const filterInvalid = s => s === 'undefined' || s === null ? '' : s

const AddNewClients = () => {
	const dispatch = useDispatch()
	const history = useHistory()
	const windowUrl = window.location.search
	const params = new URLSearchParams(windowUrl)
    const clientId = params.get('clientId')
    const resolvedClientAccountName = useAccountTypeName('client')
    const resolvedGymAccountName = useAccountTypeName('gym')
    const client = useSelector(state => selectClientsById(state, clientId))
    const isGym = true

    //helper function for saving S3 urls in profile data
	const saveUploadToProfile = (uploadKey,url)=>{
		envAwarePost('api/users/api/',{
			action:'updateClientProfileData',
			client_id:clientId,
			using_s3:1,
			[uploadKey]:url
		})
	}
	//Note: these will post to the new api endpoint with 
	//the S3 url if the upload to S3 succeeds
	//custom hook for S3 signed url direct uploads
	const {
		handleUpload:handleContractUpload,
		clearUpload:clearContract,
		//destructure in a "useState" like way
		setUpload:setNewContract,
		file:newContract
	} = useDirectUpload({ //DEPRECATED use useS3DirectUploadInstead
		//once file successfully saved on S3 save the url in or records
		success:(url)=>{ 
			saveUploadToProfile('new_contract',url)
			//update state with new contract
			dispatch(setClientKey({
				userId:clientId,
				key:'contract',
				val:url,
			}))
			clearContract()
		},
		fail:()=>{}
	})
	
	const {
		handleUpload:handleOtherFileUpload,
		clearUpload:clearOtherFile,
		//destructure in a "useState" like way
		setUpload:setNewOtherFile,
		file:newOtherFile
	} = useDirectUpload({ //DEPRECATED use useS3DirectUploadInstead
		//once file successfully saved on S3 save the url in or records
		success:(url)=>{ 
			saveUploadToProfile('new_par_q',url)
			//update state with new other file
			dispatch(setClientKey({
				userId:clientId,
				key:'par_q',
				val:url,
			}))
			clearOtherFile()
		},
		fail:()=>{}
	})

	//set up local state
	const [userName,setUserName] = useState('')
	const [email,setEmail] = useState('')
	const [profilePic,setProfilePic] = useState()
	const [newProfilePic,setNewProfilePic] = useState()
	const [phone,setPhone] = useState('')
	const [sex,setSex] = useState('')
	const [height,setHeight] = useState('')
	const [heightUnits,setHeightUnits] = useState(0)
	const [birthdate,setBirthdate] = useState('')
	const [likes,setLikes] = useState('')
	const [dislikes,setDislikes] = useState('')
	const [goals,setGoals] = useState('')
	const [injuries,setInjuries] = useState('')
	const [showPasswordModal,setShowPasswordModal] = useState(false)
	const [trainerId,setTrainerId] = useState(0)
	const [setupClientAccount,setSetupClientAccount] = useState(true)
	const [emailClient,setEmailClient] = useState(true)
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        dispatch(getAllClients())
        dispatch(getAllTags())
    },[])

	//only used when adding clients
	//password changes occur in update modal
	const [password,setPassword] = useState(null)

	//save changes handler
	const saveHandler = ()=>{
		const isNewClient = !Boolean(clientId)
		const payload = {
			dateOfBirth:dateToAPIForm(birthdate).split(' ')[0],
			birthdate:dateToAPIForm(birthdate).split(' ')[0],
			operation:isNewClient?'add':'edit',
			clientDisplayName:userName,
			height_units:heightUnits,
			clientEmail:email,
			dislikes,
			injuries,
			height,
			phone,
			goals,
			likes,
			sex,
		}
		//conditionally set some paramters

		//only add profie pic & other uploads to request
		//if they have been updated - otherwise the server
		//will overwrite with empty files
		if(newProfilePic){
			payload.operationProfileImage = 'edit'
			payload.profilePicFile = newProfilePic
		}

		//only add trainer_id if it's set otherwise the client 
		//will not be associated with a trainer
		payload.trainer_id = trainerId

		//to prevent "invalid client" response
		//only set client_id if this is not for new clients
		if(isNewClient){
			payload.setupClientAccount = Number(setupClientAccount)
			payload.emailClient = emailClient ? 1 : 0
			payload.clientPassword = password
			
		}else{
			payload.client_id = clientId
		}
		//validate data
		if(isNewClient){
			if(setupClientAccount){
				if(!password||!email||!userName){
					alert('Must provide password, email & display name')
					return
				}
			}else{
				if(!userName){
					alert('Must provide a display name')
					return
				}
			}
		}
		setIsSubmitting(true);
		//use formSubmit since we are including files
		envAwareFormSubmit({
			path:'clientAddEditDeleteMobWeb.php',
			payload
		}).then(res=>{
			const success = res.success
			const clientId = res.firebaseData.clientUserIDNumber
			//refetch client list to reflect new addition
			setIsSubmitting(false);
			if(success === '1'){
				dispatch(getAllClients()).then(()=>{
					//do this now to prevent race condition
					//if other file or contract are set trigger
					//the S3 upload flow
					if(newOtherFile) handleOtherFileUpload()
					if(newContract) handleContractUpload()
				})
				history.push(`/clients`)
			}else{
				alert(res.message)
			}
		})
	}

	//depending on when users enter this screen the users
	//may not be loaded so client might be null. To account for this,
	//useEffect lists for client updates & sets state
	useEffect(()=>{
		if(!client) return 
		setUserName(filterInvalid(client.user_name))
		setEmail(filterInvalid(client.user_email))
		setProfilePic(filterInvalid(client.profile_pic))
		setPhone(filterInvalid(client.phone))
		setSex(filterInvalid(client.sex))
		setHeight(filterInvalid(client.height))
		setHeightUnits(filterInvalid(client?.height_units))
		setBirthdate(filterInvalid(
			client?.birthdate && (client?.birthdate!=='0000-00-00') ? 
			new Date(client.birthdate.replace(/-/g, '\/')) : 
			''
		))
		setLikes(filterInvalid(client?.likes))
		setDislikes(filterInvalid(client?.dislikes))
		setGoals(filterInvalid(client?.goals))
		setInjuries(filterInvalid(client?.injuries))
		setTrainerId(filterInvalid(client?.user_trainer_id))
	},[client])

	return (
		<div className="p-3 w-100" style={{flex:'1 1 auto',overflow:'auto'}}>
            <h1>{Boolean(clientId) ? 'Edit' : 'Add'} {resolvedClientAccountName}</h1>
			<hr/>
			<div style={{
				display:'grid',
				gridTemplateColumns:'repeat(auto-fit,minmax(min(400px,100%),1fr))',
				gridGap:'16px'
			}}>
				<div className="border rounded p-3 bg-light">
					<h2 className="text-center">Account Info</h2>
					<div>
						<strong><label className="d-block mt-1">Display Name</label></strong>
						<Form.Control onChange={e=>setUserName(e.target.value)} value={userName}/>
						{
							//only display email if editting a client
							//or we want to enable client account setup
							(Boolean(setupClientAccount)||Boolean(clientId))&&
							<div>
								<strong><label>Email</label></strong>
								<Form.Control onChange={e=>setEmail(e.target.value)} value={email}/>
								{Boolean(clientId)&&<a href={`mailto:${email}`}>Send Email</a>}
							</div>
						}
						{
							//only display password label if editting a client
							//or setting up a new client account
							(Boolean(clientId)||Boolean(setupClientAccount))&&
							<strong><label>Password</label></strong>
						}
						{
							//display change password option for existing clients
							Boolean(clientId)&&
							<button 
								onClick={()=>setShowPasswordModal(true)}
								style={{border:'none',background:'none'}} 
								className="text-primary"
							>
								change password
							</button>
						}
						{
							//only display email if adding a new client
							//or we want to enable client account setup
							(!Boolean(clientId)&&Boolean(setupClientAccount))&&
							<Form.Control onChange={e=>setPassword(e.target.value)} value={password}/>
						}
					</div>
					{!Boolean(clientId)&&
						<div>
							<strong><label>Settings</label></strong>
							<div>
								<Form.Check 
									id="setupClientAccount"
									onChange={e=>setSetupClientAccount(e.target.checked)}
									checked={setupClientAccount}
									type="checkbox" 
									label="Enable Client to Login"
								/>
							</div>
							<div>
								<Form.Check 
									id="emailClient"
									onChange={e=>setEmailClient(e.target.checked)}
									checked={emailClient}
									type="checkbox" 
									label="Send Automated Welcome Email" />
							</div>
						</div>
					}
				</div>
				<div className="border rounded p-3 bg-light">
					<h2 className="text-center">General Info</h2>
					<img width={150} height={150} style={{ objectFit: 'cover' }} className="rounded-circle d-block m-auto" src={profilePic ? profilePic : "https://cdn.fitsw.com/assets/img/defaultProfile.png"}/>
					<div className="d-flex justify-content-around">
						{client?.date_create ? 
							(
								<small>
									Signed up: {new Date(client?.date_create?.split(' ').join('T')).toLocaleDateString()}
								</small>
							):null
						}
						{(new Date(client?.last_login?.split(' ').join('T')).toLocaleDateString() !== "Invalid Date") ? (
							<small>
								{console.log((client?.last_login?.split(' ').join('T')))}
							Last Login: {
								new Date(client?.last_login?.split(' ').join('T')).toLocaleDateString()
								
							}
							</small>
						) : null}
					</div>
					<Form.File 
						className="mt-2"
						onChange={e=>{
							setNewProfilePic(e.target.files[0])
						}}
						label="New Profile Pic" custom/>
					<div>
						{Boolean(newProfilePic) && ellipsis(newProfilePic.name,40)}
					</div>
					<div className="mt-2">
						<strong><label className="d-block">Phone (optional)</label></strong>
						<Form.Control onChange={e=>setPhone(e.target.value)} value={phone}/>
					</div>
				</div>
				<div className="border rounded p-3 bg-light">
					<h2 className="text-center">Bio Data</h2>
					<div>
						<strong><label className="d-block">Date of Birth (optional)</label></strong>
						<DatePicker
							selected={birthdate}
							onChange={date=>setBirthdate(date)}
							dateFormat="MMM d, yyyy"
							popperModifiers={{
								preventOverflow: {
									enabled: true,
									escapeWithReference: false,
									boundariesElement: 'viewport'
								}
							}}
							customInput={<Form.Control/>}/>
					</div>
					<strong><label>Sex (optional)</label></strong>
					<Form.Control onChange={e=>setSex(e.target.value)} as="select" value={sex}>
						<option value="Not Selected">Not Selected</option>
						<option value="Male">Male</option>
						<option value="Female">Female</option>
						<option value="Other">Other</option>
					</Form.Control>
					<div>
						<strong><label>Height (optional)</label></strong>
						<div className="d-flex">
							<Form.Control onChange={e=>setHeight(e.target.value)} value={height}/>
							<Form.Control as="select" onChange={e=>setHeightUnits(e.target.value)} value={heightUnits}>
								<option value={0}>in</option>
								<option value={1}>cm</option>
							</Form.Control>
						</div>

					</div>
				</div>
				<div className="border rounded p-3 bg-light">
					<h2 className="text-center">Preferences</h2>
					<div>
						<div>
							<strong><label>Goals</label></strong>
							<Form.Control value={goals} onChange={e=>setGoals(e.target.value)} as="textarea"/>
						</div>
						<div>
							<strong><label>Likes</label></strong>
							<Form.Control value={likes} onChange={e=>setLikes(e.target.value)} as="textarea"/>
						</div>
						<div>
							<strong><label>Dislikes</label></strong>
							<Form.Control value={dislikes} onChange={e=>setDislikes(e.target.value)} as="textarea"/>
						</div>
						<div>
							<strong><label>Injuries / Conditions</label></strong>
							<Form.Control value={injuries} onChange={e=>setInjuries(e.target.value)} as="textarea"/>
						</div>
					</div>
				</div>
				<Notes clientId={clientId}/>
				<Tags clientId={clientId}/>
				<Uploads 
					newContract={newContract}
					newOtherFile={newOtherFile}
					newOtherFileHandler={e=>setNewOtherFile(e.target.files[0])}
					newContractHandler={e=>setNewContract(e.target.files[0])} 
					clientId={clientId}
				/>
				{isGym&&
					<GymOptions 
						trainerId={trainerId}
						onTrainerSelect={(newTrainerId)=>{
							setTrainerId(newTrainerId)
						}}
						clientId={clientId}
					/>
				}
			</div>
			<Button onClick={saveHandler} variant="primary" block className="mt-3">
				{isSubmitting ? 
					<Spinner animation="border" role="status">
						<span className="sr-only">Loading...</span>
					</Spinner> 
					: "Save Data" 
				}
				</Button>
			<ChangePasswordModal 
				clientId={clientId}
				show={showPasswordModal} 
				setShow={setShowPasswordModal}/>
		</div>
	)
}

export default AddNewClients